<!-- Atomic preset outlined, rounded, small p-button - the same treatment as the AI suggestions
     "send snippet" action - so colors, hover, focus ring, disabled and dark mode all come from the
     theme. p-chip isn't used: it renders a non-interactive div. The handoff chip looks the
     same as the reply chips. -->
<div
  class="mt-2 flex flex-row flex-wrap gap-2"
  role="group"
  [attr.aria-label]="'cl_chat.aiQuickRepliesLabel' | translate"
  data-e2e="ai-quick-replies"
>
  @for (option of options(); track option + $index) {
    <p-button
      variant="outlined"
      size="small"
      [rounded]="true"
      [label]="option"
      [disabled]="disabled()"
      (onClick)="selected.emit(option)"
      data-e2e="ai-quick-reply"
    />
  }
  @if (handoffLabel()) {
    <p-button
      variant="outlined"
      size="small"
      [rounded]="true"
      [label]="handoffLabel()"
      [disabled]="disabled()"
      (onClick)="handoff.emit()"
      data-e2e="ai-handoff"
    />
  }
</div>
